import React from "react";
import { ReleaseCardModel } from "./HomeLandingModel";
import ValuePickCard from "./ValuePickCard";

export default function ValuePicksRow({
  items,
}: {
  items: readonly ReleaseCardModel[];
}) {
  return (
    <div className="homeLandingVFMCarousel">
      {items.map((item) => (
        <ValuePickCard key={item.id} item={item} />
      ))}
    </div>
  );
}
